const log = {
    invalid_type: '日誌類型無效。',
};
export default Object.freeze(log);
